import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { MARGIN_COLUMN, SUB_NETWORK_MARGIN_MODULE } from "../constant/subNetworkConstant";

export const setMarginPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: SUB_NETWORK_MARGIN_MODULE,
        default_columns: MARGIN_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
